import { useState, useCallback } from 'react';
import api from '../services/api';

/**
 * Gate the estimate-creation flow behind "today's gold rate is entered".
 *
 * Usage:
 *   const gate = useGoldRateGate();
 *   const ok = await gate.check();
 *   if (!ok) return;              // dialog auto-opens, notify auto-fires
 *   openEstimateForm();
 *
 * Render <GoldRateGateDialog {...gate.dialogProps} /> once near the trigger.
 */
export default function useGoldRateGate() {
  const [open, setOpen] = useState(false);

  const check = useCallback(async () => {
    try {
      const r = await api.get('/gold-prices/today');
      if (r.data?.exists) return true;
    } catch (_e) {
      // If the check itself fails, don't block the user — server will
      // still reject at Save, showing its own message.
      return true;
    }
    // Not entered → open the popup and notify cashiers (fire-and-forget)
    setOpen(true);
    api.post('/gold-prices/notify-missing').catch(() => {});
    return false;
  }, []);

  return {
    check,
    dialogProps: { open, onOpenChange: setOpen },
  };
}
